// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1L83W","modalForm":"UpgradeEpcsModal_modalForm__IUymo","modalFooter":"UpgradeEpcsModal_modalFooter__3D5l9"};